'use client';

import { useEffect } from 'react';

/**
 * Client Component that performs an immediate full-page redirect via `window.location.replace()`.
 *
 * Use this instead of Next.js `redirect()` when a Server Component conditionally returns JSX
 * or a redirect — the RSC `redirect()` gets embedded in the RSC payload and causes a
 * client-side exception. `window.location.replace()` navigates as a top-level request and
 * doesn't create a history entry (matching HTTP redirect semantics).
 */
export interface ClientRedirectProps {
  url: string;
}

export function ClientRedirect({ url }: ClientRedirectProps) {
  useEffect(() => {
    if (url.startsWith('/')) {
      window.location.replace(url);
    }
  }, [url]);

  return null;
}
